import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent } from './components/button/button.component';
import { SpinnerModule } from '../spinner/spinner.module';

@NgModule({
  declarations: [ButtonComponent],
  imports: [CommonModule, TranslateModule, SpinnerModule],
  exports: [ButtonComponent]
})
export class ButtonModule {}
